/**
 * Definisi menu sidebar — pure utils agar aman di client & Nitro server.
 */
export interface menu {
  header?: string;
  headerKey?: string;
  title?: string;
  titleKey?: string;
  icon?: any;
  to?: string;
  /** Exact route match only (hubs that prefix other menus). */
  exact?: boolean;
  chip?: string;
  BgColor?: string;
  chipBgColor?: string;
  chipColor?: string;
  chipVariant?: string;
  chipIcon?: string;
  children?: menu[];
  disabled?: boolean;
  type?: string;
  subCaption?: string;
  external?: boolean;
}

/**
 * Menu konsultan pajak & akuntansi profesional.
 * Nested children didukung NavCollapse — hindari daftar flat yang panjang.
 */
const sidebarItem: menu[] = [
  { header: 'Kerja Bulan', headerKey: 'nav.section.monthDesk' },
  { title: 'Dashboard', titleKey: 'nav.dashboard', icon: 'widget-2-line-duotone', to: '/', exact: true },
  {
    title: 'Meja Bank',
    titleKey: 'nav.monthBank',
    icon: 'transfer-horizontal-bold-duotone',
    children: [
      {
        title: 'E-Statement Pintar',
        titleKey: 'nav.statements',
        icon: 'cloud-upload-line-duotone',
        to: '/statements',
      },
      {
        title: 'Rekonsiliasi',
        titleKey: 'nav.reconciliation',
        icon: 'transfer-horizontal-bold-duotone',
        to: '/reconciliation',
      },
      {
        title: 'Posisi Kas/Bank',
        titleKey: 'nav.cashBank',
        icon: 'wallet-money-line-duotone',
        to: '/cash-bank',
      },
    ],
  },
  {
    title: 'Meja Pajak',
    titleKey: 'nav.monthTax',
    icon: 'calculator-line-duotone',
    children: [
      {
        title: 'Omset',
        titleKey: 'nav.omsetYearly',
        icon: 'graph-up-line-duotone',
        to: '/reports/omset',
      },
      {
        title: 'PPh Final 0,5%',
        titleKey: 'nav.taxHubHome',
        icon: 'calculator-line-duotone',
        to: '/tax',
        exact: true,
      },
      {
        title: 'PPh 23 / Bukti Potong',
        titleKey: 'nav.withholdings',
        icon: 'bill-list-line-duotone',
        to: '/tax/withholdings',
      },
      {
        title: 'SSP / e-Bupot',
        titleKey: 'nav.ssp',
        icon: 'wad-of-money-line-duotone',
        to: '/tax/ssp',
      },
      {
        title: 'SPT Masa Pack',
        titleKey: 'nav.sptMasa',
        icon: 'document-text-line-duotone',
        to: '/tax/spt-masa',
      },
    ],
  },
  {
    title: 'Tutup Bulan',
    titleKey: 'nav.closeWizard',
    icon: 'calendar-mark-line-duotone',
    to: '/journals/close-wizard',
  },
  {
    title: 'Laporan Keuangan',
    titleKey: 'nav.financialStatements',
    icon: 'chart-square-line-duotone',
    to: '/reports/lk',
  },
  {
    title: 'Karyawan & Gaji',
    titleKey: 'nav.employees',
    icon: 'user-rounded-line-duotone',
    to: '/hr/employees',
  },

  { header: 'Utama', headerKey: 'nav.section.main' },
  {
    title: 'Kalender',
    titleKey: 'nav.calendar',
    icon: 'calendar-mark-line-duotone',
    to: '/calendar',
  },
  {
    title: 'Aktifitas',
    titleKey: 'nav.activities',
    icon: 'checklist-line-duotone',
    children: [
      {
        title: 'Reminder',
        titleKey: 'nav.reminders',
        icon: 'bell-line-duotone',
        to: '/reminders',
        chip: '',
        chipColor: 'error',
      },
      {
        title: 'Kasbon',
        titleKey: 'kasbon',
        icon: 'wallet-money-line-duotone',
        to: '/hr/employees?tab=kasbon',
        chip: '',
        chipColor: 'warning',
      },
    ],
  },
  {
    title: 'Tutup Periode',
    titleKey: 'nav.periodClose',
    icon: 'checklist-line-duotone',
    children: [
      {
        title: 'Tutup Bulan',
        titleKey: 'nav.closeWizard',
        icon: 'calendar-mark-line-duotone',
        to: '/journals/close-wizard',
      },
      {
        title: 'Checklist Tutup',
        titleKey: 'nav.closeChecklist',
        icon: 'checklist-minimalistic-line-duotone',
        to: '/control/close-checklist',
      },
    ],
  },

  { header: 'Buku Jurnal', headerKey: 'nav.section.journal' },
  {
    title: 'Jurnal',
    titleKey: 'nav.journals',
    icon: 'document-text-line-duotone',
    children: [
      {
        title: 'Hub Jurnal',
        titleKey: 'nav.journalsHub',
        icon: 'widget-line-duotone',
        to: '/journals',
        exact: true,
      },
      {
        title: 'Jurnal Cepat',
        titleKey: 'nav.quickJournal',
        icon: 'pen-new-square-line-duotone',
        to: '/quick-journal',
      },
      {
        title: 'Buat Jurnal',
        titleKey: 'nav.multiJournal',
        icon: 'document-add-line-duotone',
        to: '/journals/entry',
      },
      {
        title: 'Cari Ref ID',
        titleKey: 'nav.lookupRef',
        icon: 'magnifer-line-duotone',
        to: '/journals/lookup',
      },
      {
        title: 'Pembetulan',
        titleKey: 'nav.correction',
        icon: 'restart-circle-line-duotone',
        to: '/journals/pembetulan',
      },
      {
        title: 'Saldo Awal',
        titleKey: 'nav.openingBalance',
        icon: 'restart-circle-line-duotone',
        to: '/opening-balance',
      },
      {
        title: 'Approval Jurnal',
        titleKey: 'nav.journalApprovals',
        icon: 'check-circle-line-duotone',
        to: '/journals/approvals',
      },
      {
        title: 'Dimensi',
        titleKey: 'nav.dimensions',
        icon: 'layers-line-duotone',
        to: '/journals/dimensions',
      },
    ],
  },

  { header: 'Kas & Impor', headerKey: 'nav.section.cashImport' },
  {
    title: 'Impor & Statement',
    titleKey: 'nav.importGroup',
    icon: 'cloud-upload-line-duotone',
    children: [
      {
        title: 'E-Statement Pintar',
        titleKey: 'nav.statements',
        icon: 'cloud-upload-line-duotone',
        to: '/statements',
      },
      {
        title: 'Impor Data',
        titleKey: 'nav.import',
        icon: 'upload-minimalistic-line-duotone',
        to: '/import',
      },
    ],
  },
  {
    title: 'Rekonsiliasi',
    titleKey: 'nav.reconciliation',
    icon: 'transfer-horizontal-bold-duotone',
    to: '/reconciliation',
    chip: '',
    chipColor: 'error',
  },
  {
    title: 'Posisi Kas/Bank',
    titleKey: 'nav.cashBank',
    icon: 'wallet-money-line-duotone',
    to: '/cash-bank',
  },
  {
    title: 'Rekening Bank',
    titleKey: 'nav.updateRekening',
    icon: 'card-send-line-duotone',
    to: '/bank-accounts',
  },

  { header: 'Master Data', headerKey: 'nav.section.master' },
  {
    title: 'Perusahaan & NPWP',
    titleKey: 'nav.companies',
    icon: 'buildings-2-line-duotone',
    to: '/companies',
  },
  {
    title: 'Klien / WP',
    titleKey: 'nav.clients',
    icon: 'users-group-rounded-line-duotone',
    to: '/clients',
  },
  {
    title: 'Engagement & Fee',
    titleKey: 'nav.engagements',
    icon: 'wad-of-money-line-duotone',
    to: '/engagements',
  },
  {
    title: 'Invoice & Proforma',
    titleKey: 'nav.invoices',
    icon: 'bill-list-line-duotone',
    to: '/invoices',
  },
  {
    title: 'Tagihan Vendor',
    titleKey: 'nav.vendorBills',
    icon: 'bill-check-line-duotone',
    to: '/vendor-bills',
  },
  {
    title: 'Aset Tetap',
    titleKey: 'nav.fixedAssets',
    icon: 'buildings-3-line-duotone',
    to: '/fixed-assets',
  },
  {
    title: 'Jurnal Berulang',
    titleKey: 'nav.recurringJournals',
    icon: 'calendar-mark-line-duotone',
    to: '/recurring-journals',
  },
  {
    title: 'Marketing & WA',
    titleKey: 'nav.marketing',
    icon: 'chat-round-line-duotone',
    to: '/marketing',
  },
  {
    title: 'WhatsApp',
    titleKey: 'nav.whatsapp',
    icon: 'dialog-2-line-duotone',
    to: '/whatsapp',
  },
  {
    title: 'Kalkulator Kurs',
    titleKey: 'nav.kurs',
    icon: 'calculator-line-duotone',
    to: '/kurs',
  },
  {
    title: 'Produk',
    titleKey: 'nav.products',
    icon: 'box-minimalistic-line-duotone',
    to: '/products',
  },
  {
    title: 'Daftar Akun',
    titleKey: 'nav.accounts',
    icon: 'notebook-minimalistic-line-duotone',
    to: '/accounts',
    chip: '',
    chipColor: 'warning',
  },
  {
    title: 'Portal Saya',
    titleKey: 'nav.hrPortal',
    icon: 'user-hand-up-line-duotone',
    to: '/hr/me',
    chip: '',
    chipColor: 'primary',
  },
  {
    title: 'Karyawan & Gaji',
    titleKey: 'nav.employees',
    icon: 'user-rounded-line-duotone',
    to: '/hr/employees',
    chip: '',
    chipColor: 'error',
  },
  {
    title: 'Absensi Karyawan',
    titleKey: 'nav.attendance',
    icon: 'calendar-mark-line-duotone',
    to: '/hr/attendance',
    chip: '',
    chipColor: 'info',
  },
  {
    title: 'Slip Gaji',
    titleKey: 'nav.payslips',
    icon: 'bill-list-line-duotone',
    to: '/hr/payslips',
    chip: '',
    chipColor: 'success',
  },

  { header: 'Laporan', headerKey: 'nav.section.report' },
  {
    title: 'Pusat Laporan',
    titleKey: 'nav.reportsHub',
    icon: 'widget-line-duotone',
    to: '/reports',
    exact: true,
  },
  {
    title: 'Download Laporan',
    titleKey: 'nav.downloadReports',
    icon: 'download-minimalistic-line-duotone',
    to: '/downloads',
  },
  {
    title: 'Laporan Inti',
    titleKey: 'nav.coreReports',
    icon: 'document-medicine-line-duotone',
    children: [
      {
        title: 'Laporan Keuangan',
        titleKey: 'nav.financialStatements',
        icon: 'document-medicine-line-duotone',
        to: '/reports/lk',
      },
      {
        title: 'Konsolidasi JGI+JGT',
        titleKey: 'nav.consolidated',
        icon: 'buildings-2-line-duotone',
        to: '/reports/consolidated',
      },
      {
        title: 'Antar Perusahaan',
        titleKey: 'nav.intercompany',
        icon: 'transfer-horizontal-bold-duotone',
        to: '/reports/intercompany',
      },
      {
        title: 'Uang Muka / DP',
        titleKey: 'nav.unearned',
        icon: 'wad-of-money-line-duotone',
        to: '/reports/unearned',
      },
      {
        title: 'Neraca Saldo',
        titleKey: 'nav.trialBalance',
        icon: 'checklist-minimalistic-line-duotone',
        to: '/reports/trial-balance',
      },
      {
        title: 'Laba Rugi',
        titleKey: 'nav.incomeStatement',
        icon: 'graph-up-line-duotone',
        to: '/reports/income-statement',
      },
      {
        title: 'Neraca',
        titleKey: 'nav.balanceSheet',
        icon: 'chart-square-line-duotone',
        to: '/reports/balance-sheet',
      },
      {
        title: 'Arus Kas',
        titleKey: 'nav.cashFlow',
        icon: 'wad-of-money-line-duotone',
        to: '/reports/cash-flow',
      },
      {
        title: 'Buku Besar',
        titleKey: 'nav.ledger',
        icon: 'book-line-duotone',
        to: '/reports/ledger',
      },
      {
        title: 'Omset Tahunan',
        titleKey: 'nav.omsetYearly',
        icon: 'calendar-mark-line-duotone',
        to: '/reports/omset',
      },
    ],
  },

  { header: 'Pajak', headerKey: 'nav.section.tax' },
  {
    title: 'Pusat Pajak',
    titleKey: 'nav.taxHub',
    icon: 'calculator-line-duotone',
    children: [
      {
        title: 'PPh Final 0,5%',
        titleKey: 'nav.taxHubHome',
        icon: 'calculator-line-duotone',
        to: '/tax',
        exact: true,
      },
      {
        title: 'Kalender Pajak',
        titleKey: 'nav.taxCalendar',
        icon: 'calendar-mark-line-duotone',
        to: '/tax/calendar',
      },
      {
        title: 'Rekap PPN',
        titleKey: 'nav.taxVat',
        icon: 'bill-list-line-duotone',
        to: '/tax/vat',
      },
      {
        title: 'Kalkulator PPh 21',
        titleKey: 'nav.taxPph21',
        icon: 'wallet-money-line-duotone',
        to: '/tax/pph21',
      },
      {
        title: 'SPT Masa Pack',
        titleKey: 'nav.sptMasa',
        icon: 'document-text-line-duotone',
        to: '/tax/spt-masa',
      },
      {
        title: 'PPh 23 / Bukti Potong',
        titleKey: 'nav.withholdings',
        icon: 'bill-list-line-duotone',
        to: '/tax/withholdings',
      },
      {
        title: 'SSP / e-Bupot',
        titleKey: 'nav.ssp',
        icon: 'wad-of-money-line-duotone',
        to: '/tax/ssp',
      },
      {
        title: 'Koreksi Fiskal',
        titleKey: 'nav.fiscal',
        icon: 'document-add-line-duotone',
        to: '/tax/fiscal',
      },
      {
        title: 'Surat & Berkas',
        titleKey: 'nav.taxDocuments',
        icon: 'folder-with-files-line-duotone',
        to: '/tax/documents',
      },
      {
        title: 'Request Pajak',
        titleKey: 'nav.taxRequests',
        icon: 'checklist-line-duotone',
        to: '/tax/requests',
        exact: true,
      },
      {
        title: 'Request Saya',
        titleKey: 'nav.taxRequestsMe',
        icon: 'user-hand-up-line-duotone',
        to: '/tax/requests/me',
      },
    ],
  },

  { header: 'Customer', headerKey: 'nav.section.customer' },
  {
    title: 'Portal Customer',
    titleKey: 'nav.customerPortal',
    icon: 'user-rounded-line-duotone',
    to: '/portal',
  },
  {
    title: 'Kelola Customer',
    titleKey: 'nav.customers',
    icon: 'users-group-rounded-line-duotone',
    to: '/customers',
  },

  { header: 'Kontrol', headerKey: 'nav.section.control' },
  {
    title: 'Kelengkapan Data',
    titleKey: 'nav.quality',
    icon: 'checklist-minimalistic-line-duotone',
    to: '/control/quality',
    chip: '',
    chipColor: 'warning',
  },
  {
    title: 'Jejak Audit',
    titleKey: 'nav.audit',
    icon: 'history-line-duotone',
    to: '/audit',
  },
  {
    title: 'Backup & Restore',
    titleKey: 'nav.backup',
    icon: 'cloud-storage-line-duotone',
    to: '/backup',
  },
  {
    title: 'User & Akses',
    titleKey: 'nav.users',
    icon: 'users-group-rounded-line-duotone',
    to: '/users',
  },
  {
    title: 'Tasya Livechat',
    titleKey: 'nav.tasya',
    icon: 'dialog-2-line-duotone',
    to: '/tasya',
  },
];

export default sidebarItem;
